<template>
  <div class="container-fluid h-100">
    <CrearMovimiento
      @movimiento-creado="filtrar"
      :tipo-movimiento="tipoMovimiento"
    ></CrearMovimiento>
    <div class="row h-100">
      <div class="col h-100">
        <card-item
          class="striped-tabled-with-hover"
          body-classes="table-full-width table-responsive"
        >
          <template slot="header">
            <div class="d-flex justify-content-between">
              <div>
                <h4 class="card-title">CAJA</h4>
              </div>
              <div class="button-group">
                <button
                  @click="crearMovimiento('Ingreso')"
                  class="btn btn-warning"
                >
                  + Ingreso
                </button>
                <button
                  @click="crearMovimiento('Egreso')"
                  class="btn btn-primary"
                >
                  + Egreso
                </button>
              </div>
            </div>
          </template>

          <div class="container-fluid h-100">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <card-item for="quickFilter" class="label">
                    <div class="row align-items-center">
                      <div class="col-12 form-group">
                        <label for="quickFilter" class="label"
                          >Filtro rapido</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="quickFilter"
                          v-model="quickFilter"
                        />
                      </div>
                    </div>
                    <div class="row align-items-center">
                      <div class="col-12 col-md-4">
                        <div class="form-group">
                          <label for="desde"> Desde </label>
                          <input
                            v-model="desde"
                            class="form-control"
                            id="desde"
                            type="datetime-local"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-md-4">
                        <div class="form-group">
                          <label for="hasta"> HASTA </label>
                          <input
                            v-model="hasta"
                            class="form-control"
                            id="hasta"
                            type="datetime-local"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-md-4">
                        <button
                          @click="filtrar"
                          v-promise-btn
                          class="btn btn-large btn-block btn-primary"
                        >
                          Filtrar
                        </button>
                      </div>
                    </div>
                  </card-item>
                  <card-item>
                    <CajaTabla ref="cajaTabla"></CajaTabla>
                  </card-item>
                </div>
              </div>
            </div>
          </div>
        </card-item>
      </div>
    </div>
  </div>
</template>

<script>
import CrearMovimiento from "./CrearMovimiento/CrearMovimiento";
import CajaTabla from "./Index/CajaTabla";

export default {
  name: "Caja-Component",
  data() {
    return {
      tipoMovimiento: "",
      quickFilter: "",
      // gridApi: null,
    };
  },
  components: {
    CajaTabla,
    CrearMovimiento,
  },
  methods: {
    async filtrar() {
      this.$refs.cajaTabla.gridApi.showLoadingOverlay();
      await this.$store.dispatch("Movimientos/getMovimientos");
      this.$refs.cajaTabla.gridApi.hideOverlay();
    },
    crearMovimiento(tipoMovimiento) {
      this.tipoMovimiento = tipoMovimiento;
      this.$bvModal.show("crearMovimientoModal");
    },
  },
  computed: {
    desde: {
      get() {
        return this.$store.getters["Movimientos/getDesde"];
      },
      set(newValue) {
        this.$store.dispatch("Movimientos/setDesde", newValue);
      },
    },

    hasta: {
      get() {
        return this.$store.getters["Movimientos/getHasta"];
      },
      set(newValue) {
        this.$store.dispatch("Movimientos/setHasta", newValue);
      },
    },
  },
  watch: {
    quickFilter(val) {
      this.$refs.cajaTabla.gridApi.setQuickFilter(val);
    },
  },
};
</script>

<style scoped></style>
